export default "__VITE_ASSET__dkcVqtgX__"